export default __webpack_public_path__ + "static/media/BackGround.b2395032.png";